<template>
    <div class="strike my-5"></div>
</template>

<script>
export default {
  data() {
    return {
   
  }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/page1/border.vue